var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "article",
    [
      (_vm.isLogin
      ? this.$store.state.sessionInfo.userInfo.scurtyDeviVndrDstcd ===
        this.$config.SCURTY_DEVI_VNDR_DSTCD_004
      : this.scurtyDeviVndrDstcd === this.$config.SCURTY_DEVI_VNDR_DSTCD_004)
        ? _c("otp-input", {
            attrs: { NOS_INSTANCE_REFERANCE: _vm.NOS_INSTANCE_REFERANCE }
          })
        : _vm._e(),
      (_vm.isLogin
      ? this.$store.state.sessionInfo.userInfo.scurtyDeviVndrDstcd ===
        this.$config.SCURTY_DEVI_VNDR_DSTCD_701
      : this.scurtyDeviVndrDstcd === this.$config.SCURTY_DEVI_VNDR_DSTCD_701)
        ? _c("motp-input", {
            attrs: { NOS_INSTANCE_REFERANCE: _vm.NOS_INSTANCE_REFERANCE }
          })
        : _vm._e(),
      (_vm.isLogin
      ? this.$store.state.sessionInfo.userInfo.scurtyDeviVndrDstcd ===
        this.$config.SCURTY_DEVI_VNDR_DSTCD_304
      : this.scurtyDeviVndrDstcd === this.$config.SCURTY_DEVI_VNDR_DSTCD_304)
        ? _c("advanced-otp-input", {
            attrs: { NOS_INSTANCE_REFERANCE: _vm.NOS_INSTANCE_REFERANCE }
          })
        : _vm._e(),
      _c("modal-pop", {
        staticClass: "error",
        attrs: {
          opened: _vm.$store.state.common.supplCertn.supplError.active,
          confirm:
            _vm.$store.state.common.supplCertn.supplError.errBtnText === ""
              ? "MOTP-03-01-03-04"
              : _vm.$t(
                  "" + _vm.$store.state.common.supplCertn.supplError.errBtnText
                )
        },
        on: {
          "update:opened": function($event) {
            return _vm.$set(
              _vm.$store.state.common.supplCertn.supplError,
              "active",
              $event
            )
          },
          confirm: function($event) {
            typeof _vm.$store.state.common.supplCertn.supplError
              .errBtnAction === "function"
              ? _vm.$store.state.common.supplCertn.supplError.errBtnAction()
              : (_vm.$store.state.common.supplCertn.supplError.active = false)
          }
        },
        scopedSlots: _vm._u([
          {
            key: "content",
            fn: function() {
              return [
                _c("div", [
                  _c("div", { staticClass: "error-code" }, [
                    _c("i", { staticClass: "icon icon-error" }),
                    _c("div", [
                      _c("span", [_vm._v("Error Code")]),
                      _c("strong", [
                        _vm._v(
                          _vm._s(
                            _vm.$t(
                              "" +
                                _vm.$store.state.common.supplCertn.supplError
                                  .errCode
                            )
                          )
                        )
                      ])
                    ])
                  ]),
                  _vm.$store.state.common.supplCertn.supplError.errCode ==
                  "B99Z0082"
                    ? _c("p", {
                        domProps: {
                          innerHTML: _vm._s(
                            _vm.$t(
                              "" +
                                _vm.$store.state.common.supplCertn.supplError
                                  .errMsg
                            )
                          )
                        }
                      })
                    : _vm._e(),
                  _c("p", {
                    domProps: {
                      innerHTML: _vm._s(
                        _vm.$t(
                          "" +
                            _vm.$store.state.common.supplCertn.supplError.errMsg
                        )
                      )
                    }
                  }),
                  _c("p", [
                    _vm._v(_vm._s(/*전화상담*/ _vm.$t("MCOM-0000031")))
                  ]),
                  _c("div", { staticClass: "btn-area" }, [
                    _c(
                      "button",
                      {
                        staticClass: "btn lg inline",
                        on: {
                          click: function($event) {
                            _vm.$goToTel(
                              _vm.$t(
                                "지점별콜번호_" + _vm.$store.state.siteCode
                              )
                            )
                          }
                        }
                      },
                      [
                        _c("i", { staticClass: "icon icon-call" }),
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.$t(
                                "지점별전화번호_" + _vm.$store.state.siteCode
                              )
                            ) +
                            " "
                        )
                      ]
                    )
                  ])
                ])
              ]
            },
            proxy: true
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }